import { MultichainActionType } from '@popup/multichain/actions/action-type.enum';
export const openModal = ({ children, title }) => {
    return {
        type: MultichainActionType.OPEN_MODAL,
        payload: {
            title: title,
            children: children,
        },
    };
};
export const closeModal = () => {
    return {
        type: MultichainActionType.CLOSE_MODAL,
    };
};
